
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/react-use-media-query",
      function () {
        return require("private-next-pages/material-ui/react-use-media-query.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/react-use-media-query"])
      });
    }
  